import moment from 'moment-timezone';
import { LegFiJwtService } from '../../services/auth/legfi-jwt.service';
import { Category } from './accounting/category';
import { FixedAsset } from './accounting/fixed-asset';
import { Liability } from './accounting/liability';
import { Equity } from './accounting/equity';
import { User } from './user';
import { Unit } from './unit';
import Moment = moment.Moment;

export class LedgerEntry
{
    id: number;
    organizationId: number;
    batchId: string;
    entryDate: Moment;
    userId: number;
    unitId: number;
    description: string;
    memo: string;
    debit: number;
    credit: number;
    summable: number;
    accountType: string;
    accountId: number;

    createdAt: Moment;
    updatedAt: Moment;
    importedAt: Moment;

    user: User;
    unit: Unit;
    account: Category | FixedAsset | Liability | Equity;

    constructor(entry: any) {
        this.id = entry.id;
        this.organizationId = entry.organizationId;
        this.batchId = entry.batchId;
        this.userId = entry.userId;
        this.unitId = entry.unitId;
        this.description = entry.description;
        this.memo = entry.memo;
        this.debit = entry.debit;
        this.credit = entry.credit;
        this.summable = entry.summable;
        this.accountType = entry.accountType;
        this.accountId = entry.accountId;

        if (entry.user) {
            this.user = new User(entry.user);
        }
        if (entry.unit) {
            this.unit = new Unit(entry.unit);
        }

        if (entry.account) {
            if (entry.accountType.indexOf('Category') !== -1) {
                this.account = new Category(entry.account);
            }
            if (entry.accountType.indexOf('FixedAsset') !== -1) {
                this.account = new FixedAsset(entry.account);
            }
            if (entry.accountType.indexOf('Liability') !== -1) {
                this.account = new Liability(entry.account);
            }
            if (entry.accountType.indexOf('Equity') !== -1) {
                this.account = new Equity(entry.account);
            }
        }

        const timezone = LegFiJwtService.getTimezone();
        if (entry.createdAt) {
            this.createdAt = moment.utc(entry.createdAt, 'YYYY-MM-DD hh:mm:ss').tz(timezone);
        }
        if (entry.updatedAt) {
            this.updatedAt = moment.utc(entry.updatedAt, 'YYYY-MM-DD hh:mm:ss').tz(timezone);
        }
        if (entry.importedAt) {
            this.importedAt = moment.utc(entry.importedAt, 'YYYY-MM-DD hh:mm:ss').tz(timezone);
        }
        if (entry.entryDate) {
            this.entryDate = moment(entry.entryDate, 'YYYY-MM-DD');
        }
    }
}
